import { Injectable } from '@angular/core';
import {
  CustomerSearchParameters,
  FieldAgentClient,
  CustomerSearchParametersDeliverytype,
  SortParametersDirection,
  PagingParameters,
  SortParameters,
  CustomerSearchParametersCustomerStatus,
  Branch, Customer, TaxArea, Address, CustomerContact,
  CustomerStatus, WebTrackUser, ProductPrice,
  Per, ProductPriceParameters, Tally, OrderType, ProductPricesDetails,
  ManualOrderLine, TaxCalculationParameter,
  GetManualLineTaxesRequest, GetNewModeTaxesForCartRequest,
  GetManualLineTaxesRequestSaleType, GetNewModeTaxesForCartRequestSaleType,
  TaxCalculationResult, BisTrackSettings, BisTrackSettingsPaymentProvider,
  Shift4SettingsI4GoCardholderNamePrompt, Shift4SettingsI4GoStreetAddressPrompt,
  Shift4SettingsI4GoPostalCodePrompt,
  KitProductRequest,
  KitProductPrice
} from 'ep-bt-field-agent-proxy';

import { BistrackConfig, SaleType, QuantityType, ProductType, ProductSubType, PerDefaults, PerType } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';
import { QuickOrderModel } from '../models/quick-order.model';
import { QuickOrderLineModel } from '../models/quick-order-line.model';
import { EpbtFaProductService } from '../services/epbt-fa-product.service';
import { TallyEntryLineModel } from '../models/tally-entry-line.model';
import { EpbtFaTallyModel } from '../models/epbt-fa-tally.model';
import { of, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaQuickOrderService {

  public wizardStep: number = 0;
  public fromDashbard: boolean = false;

  public submutButtonLabel = "Complete";
  public submitButton: boolean = true;
  // public payLaterButton: boolean = true;
  public emailButton: boolean = true;
  public payNowButton: boolean = true;
  public paymentAmountField: boolean = false;
  public summaryView: boolean = true;
  public emailView: boolean = false;
  public shift4EnterCardDetailsView: boolean = false;
  public shift4EnterAVSView: boolean = false;
  public i4GoErrorView: boolean = false;
  public successView: boolean = false;
  public wizardView: boolean = true;
  public creCardEntryView: boolean = false;
  public errorMessage: string = "";

  public cardHolderNameDiv: boolean = false;
  public streetAddressDiv: boolean = false;
  public postalCodeDiv: boolean = false;
  public useAVS: boolean = true;

  public quickOrder: QuickOrderModel;
  public quickOrderLine: QuickOrderLineModel;
  public selectedBranchId: number;
  public selectedTextAreaId = -1;
  public selectedTransactionType = 1;
  public isOrderDisable: boolean = false;
  private taxAreas: TaxArea[] = [];
  public bisTrackSettings: BisTrackSettings;
  public webTrackUser: WebTrackUser;
  public AddOrEdit: boolean = true;
  //flags

  public customerFormFlag: boolean = false;
  public productSelectFlag: boolean = false;

  ///SelectedRelatedProcteList
  selectedRelatedproduct: any;
  kits: any = {};//models are in jp-controls

  /// <summary>
  /// Whether to show card entry UI or not.
  /// </summary>
  private _allowCardEntry: boolean;
  public get allowCardEntry(): boolean {
    return this.quickOrder && this.quickOrder.customer
      && this.quickOrder.customer.cashAccount
      && this.bisTrackSettings
      && (this.bisTrackSettings.paymentProvider == BisTrackSettingsPaymentProvider.Shift4 || this.bisTrackSettings.paymentProvider == BisTrackSettingsPaymentProvider.Epicor)
      && this.quickOrder.TotalSellPrice > 0
  }

  private _i4GoVersion: string;
  public get i4GoVersion(): string {
    if (this.bisTrackSettings)
      return this.bisTrackSettings.shift4Settings.i4GoVersion;
    else
      return "";
  }

  private _showShift4EnterAVSView: boolean;
  public get showShift4EnterAVSView(): boolean {
    if (this.bisTrackSettings)
      return (this.i4GoVersion != "" && this.i4GoVersion == "2" && this.bisTrackSettings.shift4Settings.useInHouseAVSForShift4)
        && (this.bisTrackSettings.shift4Settings.i4GoCardholderNamePrompt != Shift4SettingsI4GoCardholderNamePrompt.NotDisplayed ||
          this.bisTrackSettings.shift4Settings.i4GoStreetAddressPrompt != Shift4SettingsI4GoStreetAddressPrompt.NotDisplayed ||
          this.bisTrackSettings.shift4Settings.i4GoPostalCodePrompt != Shift4SettingsI4GoPostalCodePrompt.NotDisplayed);
    else
      return false;
  }

  //Used only desktop (new order)
  customerForDesktop: any;
  productForDesktop: any;
  contactForDesktop: any;
  addressForDesktop: any;

  //To manage design and navigations we are using "isNewOrder" flag
  isNewOrder: boolean = false;
  completeOrderFlag: boolean = false;
  currency: string;

  //To popuplate search string on the popups
  searchString: string = "";

  constructor(private client: FieldAgentClient, private config: BistrackConfig,
    private faService: EpbtFieldAgentService, private router: Router,
    private productService: EpbtFaProductService) {

    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.bisTrackSettings = bisTrackSettings;
      this.currency = this.bisTrackSettings.baseCurrency.symbol;
    });

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      if (this.webTrackUser && this.webTrackUser.bisTrackBranch)
        this.selectedBranchId = this.webTrackUser.bisTrackBranch.branchID;
    });

  }

  public setCustomer(selectedCustomer: any, subscribe: (contacts: any) => void) {
    this.quickOrder.customer = selectedCustomer;
    this.SetOrGetContacts("", true, (contacts: any) => {
      if (contacts && contacts.length > 0) {
        this.quickOrder.contact = contacts[0];
      }
      this.SetOrGetDeliveryAddressDetails("", true, (addresses: any) => {
        if (addresses && addresses.length > 0) {
          this.quickOrder.deliveryAddress = addresses[0];
        }
        this.bindValuesBasedOnConditions();
        this.SetDefaultTaxArea();
        subscribe(true);
      });
    });
  }

  public setAddress(selectedAddress: any, subscribe: (address: any) => void) {
    this.quickOrder.deliveryAddress = selectedAddress;
    this.SetDefaultTaxArea();
    subscribe(true);
  }

  bindValuesBasedOnConditions() {
    if (this.quickOrder.customer && this.quickOrder.customer.customerStatus == CustomerStatus.Prospect) {
      this.selectedTransactionType = 2;
      this.isOrderDisable = true;
    }
    else { this.isOrderDisable = false; }
  }

  //Default Value Setting Start

  //This method will be used to get default and non-default contacts
  public SetOrGetContacts(searchString: string, defaultOnly: boolean, subscribe: (contacts: any) => void) {
    if (this.quickOrder && this.quickOrder.customer) {
      var searchCustomerParams = new CustomerSearchParameters();
      searchCustomerParams.customerId = this.quickOrder.customer.customerId;
      searchCustomerParams.webTrackCustomersOnly = false;
      searchCustomerParams.defaultOnly = defaultOnly;

      searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.CustomerOrProspect;
      searchCustomerParams.customersLimitSearchToHomeBranch = true;
      searchCustomerParams.bisTrackUserID = this.config.getLoggedinUser();
      searchCustomerParams.competitor = 0;
      var page = new PagingParameters();
      page.index = 0;
      page.count = 10;
      searchCustomerParams.paging = page;
      var sort = new SortParameters();
      sort.sortColumn = "Name";
      sort.direction = SortParametersDirection.Ascending;
      searchCustomerParams.sorting = sort;
      searchCustomerParams.searchText = searchString;
      searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
      searchCustomerParams.productGroupId = 0;
      searchCustomerParams.quicklistId = 0;
      searchCustomerParams.showProductsInCurrentGroupOnly = false;

      searchCustomerParams.restrictProductGroupsToCustomer = false;
      searchCustomerParams.refineIDs = null;
      searchCustomerParams.refineValues = null;
      searchCustomerParams.priceLevels = null;
      searchCustomerParams.branchID = 0;
      searchCustomerParams.bisTrackUserHasReadAccessToTheseBranchIDs = null;
      searchCustomerParams.includeMOLTProducts = false;

      this.client.findContacts(searchCustomerParams).subscribe(res => {
        if (res) {
          subscribe(res.lines);
        }
        else {
          subscribe(null);
        }
      });
    }
  }

  //This method will be used to get default and non-default Addresses
  public SetOrGetDeliveryAddressDetails(searchString: string, defaultOnly: boolean, subscribe: (addresses: any) => void) {
    // this.deliveryAddress = null;

    if (this.quickOrder && this.quickOrder.customer) {
      var searchCustomerParams = new CustomerSearchParameters();
      searchCustomerParams.customerId = this.quickOrder.customer.customerId;
      searchCustomerParams.webTrackCustomersOnly = false;
      searchCustomerParams.defaultOnly = defaultOnly;

      searchCustomerParams.bisTrackUserHasReadAccessToTheseBranchIDs = null;
      searchCustomerParams.bisTrackUserID = 0;
      searchCustomerParams.branchID = 0;
      searchCustomerParams.competitor = 0;
      searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.NotSet;
      searchCustomerParams.customersLimitSearchToHomeBranch = false;
      searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
      searchCustomerParams.includeMOLTProducts = false;
      searchCustomerParams.paging = null;
      searchCustomerParams.priceLevels = null;
      searchCustomerParams.productGroupId = 0;
      searchCustomerParams.quicklistId = 0;
      searchCustomerParams.refineIDs = null;
      searchCustomerParams.refineValues = null;
      searchCustomerParams.restrictCustomersToSalesRep = false;
      searchCustomerParams.restrictProductGroupsToCustomer = false;
      searchCustomerParams.searchPermissions = null;
      searchCustomerParams.searchText = searchString;
      searchCustomerParams.showProductsInCurrentGroupOnly = false;
      searchCustomerParams.sorting = this.faService.sorting("", SortParametersDirection.Ascending);

      try {
        this.client.findAddresses(searchCustomerParams).subscribe(res => {
          if (res) {
            subscribe(res.lines);
          }
          else {
            subscribe(null);
          }
        });
      }
      catch (ex) {
        console.log("Error: - " + ex);
      }

    }
  }


  //This method will be used to get default tax area
  public SetDefaultTaxArea() {
    if (this.quickOrder && this.quickOrder.customer && this.selectedBranchId != -1 && this.quickOrder.selectedSalesType && this.quickOrder.deliveryAddress) {//2453 //this.deliveryAddress.addressId
      this.client.getDefaultTaxAreaID(this.selectedBranchId, this.quickOrder.customer.customerId, this.quickOrder.selectedSalesType, this.quickOrder.deliveryAddress.addressId).subscribe(res => {
        this.selectedTextAreaId = res;
        if (this.selectedTextAreaId && this.selectedTextAreaId != 0) {
          if (this.taxAreas.length <= 0) {
            this.client.getTaxAreas().subscribe(res => {
              this.taxAreas = res;
              this.quickOrder.taxArea = this.taxAreas.filter(x => x.taxAreaID == this.selectedTextAreaId)[0];
            });
          }
          else {
            this.quickOrder.taxArea = this.taxAreas.filter(x => x.taxAreaID == this.selectedTextAreaId)[0];
          }
        }
      });
    }
  }

  //Default Value Setting End


  //Quick Order Line Code Start

  public createQuickOrderLine(product: any = null, quantityType: any, quantity: number = 1, subscribe: (orderline: any) => void) {
    // product = this.productService.selectedProductItem;
    this.quickOrderLine = new QuickOrderLineModel(this.quickOrder, product, quantityType, quantity);
    this.quickOrderLine.Product.dateTimeCreated = new Date();
    this.quickOrderLine.Product.dateTimeLastModified = new Date();
    if (this.quickOrderLine.Product.manualOrderLineTypeID == 0) {
      //Below properties are used only for binding
      this.quickOrderLine.code = this.quickOrderLine.Product.productCode;

      if (this.quickOrderLine.Product.autoCreateSpecialFromThis > 0)
        this.quickOrderLine.description = this.quickOrderLine.SpecialProductDescription;
      else
        this.quickOrderLine.description = this.quickOrderLine.Product.description;

      // Load unit sell price pers and quantity input pers on the product
      this.quickOrderLine.Product.dateTimeLastModified = new Date();
      try {
        this.client.loadProductPers(this.quickOrderLine.Product).subscribe(product => {

          this.quickOrderLine.Product = product;

          this.quickOrderLine.InputPer = product.inputPer ? product.inputPer : product.inputPers[0];
          // Adjust "Sell Per" uom for certain Customers/products
          // changing the below condition because we are not updating the selected customer to WebtrackUser, so checking directly in QuickOrderModel.customer
          // if (this.webTrackUser.customer.useEachPricing && product.productType == ProductType.TimberTallied && product.productSubtype == ProductSubType.Child) {
          if (this.quickOrder.customer && this.quickOrder.customer.useEachPricing && product.productType == ProductType.TimberTallied && (product.productSubtype == ProductSubType.Child || product.productSubtype == ProductSubType.None)) {
            // set to Each if possible
            var eaches = this.quickOrderLine.Product.sellPricePers.filter(sellPer => sellPer.perId == 1); // Each is always 1

            if (eaches && eaches.length > 0) {
              var each = eaches[0];
              this.quickOrderLine.Per = each;
              if (this.quickOrderLine.Product.tallyLengths.length > 1) {
                if (this.quickOrderLine.Product.productType == ProductType.TimberTallied && this.quickOrderLine.Product.productSubtype == ProductSubType.Parent)
                  this.quickOrderLine.PerToDisplay = each;
                else {
                  this.quickOrderLine.PerToDisplay = product.sellPer;
                  //this.Per = Product.SellPer;
                }
              }
              else {
                this.quickOrderLine.PerToDisplay = each;
              }
            }
            else {
              this.quickOrderLine.Per = product.sellPer;
              this.quickOrderLine.PerToDisplay = this.quickOrderLine.Per;
            }
          }
          else {
            this.quickOrderLine.Per = product.sellPer;
            this.quickOrderLine.PerToDisplay = this.quickOrderLine.Per;
          }

          // Get Pricing Details
          var linePrice = new ProductPrice();
          this.getOrderLinePrice(false, null, (result: any) => {
            linePrice = result;
            if (linePrice.unitSellPrice == 0) {
              this.quickOrderLine.UnitSellPrice = this.quickOrderLine.Product.standardSellPrice;
            }
            else {
              this.quickOrderLine.UnitSellPrice = linePrice.unitSellPrice;
              var filteredSellPers = this.quickOrderLine.Product.sellPricePers.filter(p => p.perId == linePrice.unitSellPerID);
              this.quickOrderLine.Per = filteredSellPers && filteredSellPers.length > 0 ? filteredSellPers[0] : null;
            }
            // memorize current standard price !!!!!!!!!!
            this.quickOrderLine.CurrentStandardUnitSellPrice = this.quickOrderLine.UnitSellPrice;
            this.quickOrderLine.TotalSellPrice = linePrice.totalSellPrice;
            this.prepareTallyEntryLines(product, quantity, (result: any) => {
              console.log(result);
              subscribe(this.quickOrderLine);
            });
          });
        });
      }
      catch (ex) {
        console.log(ex);
      }
    }
    else {
      try {
        this.client.getManualOrderLineType(this.quickOrderLine.Product.manualOrderLineTypeID).subscribe(res => {
          this.quickOrderLine.ManualOrderLineType = res;

          if (this.quickOrderLine.ManualOrderLineType) {
            this.quickOrderLine.TotalSellPrice = this.quickOrderLine.ManualOrderLineType.defaultSellPrice;
            this.quickOrderLine.ManualDescription = this.quickOrderLine.ManualOrderLineType.defaultDescription;
            this.quickOrderLine.ManualCode = this.quickOrderLine.ManualOrderLineType.defaultCode;
            this.quickOrderLine.UnitCostPrice = this.quickOrderLine.ManualOrderLineType.defaultCostPrice;
            this.quickOrderLine.Quantity = 1;

            //Below properties are used only for binding
            this.quickOrderLine.code = this.quickOrderLine.ManualCode;

            if (this.quickOrderLine.ManualDescription)
              this.quickOrderLine.description = this.quickOrderLine.ManualDescription;
            else
              this.quickOrderLine.description = this.quickOrderLine.Product.description;

          }
          this.prepareTallyEntryLines(product, quantity, (result: any) => {
            console.log(result);
            subscribe(this.quickOrderLine);
          });
          // subscribe(true);
        });
      }
      catch (ex) {
        console.log(ex);
      }
    }
  }

  prepareTallyEntryLines(product: any, quantity: number = 1, subscribe: (tallyEntryLines: any) => void) {
    if (this.productService.shouldTallyProduct(product.tallyLengths)) {

      var tally: EpbtFaTallyModel;
      this.quickOrderLine.IsTally = true;

      if (this.quickOrderLine.Product.productType == ProductType.TimberTallied && this.quickOrderLine.Product.productSubtype == ProductSubType.Parent) {
        // parent tallied product, create tally entry object based on child products
        this.client.getChildProducts(this.quickOrderLine.Product.productId).subscribe(childs => {
          if (childs && childs.length > 0) {
            this.quickOrderLine.Product.childProducts = childs;
          }
          var productPrices: ProductPricesDetails[] = [];
          this.prepareProductPriceRequests(this.quickOrderLine.Product.productId, false, this.quickOrderLine.Product.childProducts, (result: any) => {
            productPrices = result;
            var counter: number = 0;
            this.quickOrderLine.TallyEntryLines = [];
            this.quickOrderLine.Product.childProducts.forEach(child => {
              child.sellPer = this.quickOrderLine.PerToDisplay;
              var price: ProductPricesDetails;

              var res = productPrices.filter(x => x.productID == child.productId);
              if (res && res.length > 0)
                price = res[0];
              if (price) {
                var entryLine: TallyEntryLineModel = new TallyEntryLineModel(
                  ++counter,
                  child.productId,
                  Number(child.tallyLengths),
                  child.width,
                  child.thickness,
                  0,
                  price.unitSellPrice,
                  this.quickOrderLine.InputPer.perId,
                  child.imperial ? "ft" : "m",
                  this.quickOrderLine.InputPer.perId,
                  this.quickOrderLine.PerToDisplay.perCode,
                  true,
                  child.imperial,
                  this.quickOrderLine.PerToDisplay);
                this.quickOrderLine.TallyEntryLines.push(entryLine);
              }
            });
            subscribe(this.quickOrderLine.TallyEntryLines);
          });
        });
      }
      else if (this.quickOrderLine.Product.productType == ProductType.TimberTallied && this.quickOrderLine.Product.productSubtype == ProductSubType.None) {
        // non parent tallied product,
        // create tally entry object based on Tally string
        tally = new EpbtFaTallyModel(this.quickOrderLine.Product.tallyLengths);
        var tallyLengths = product.tallyLengths.split(',');
        var index: number = 0;
        this.quickOrderLine.TallyEntryLines = [];
        product.inputPer = product.inputPer ? product.inputPer : this.quickOrderLine.InputPer;
        tallyLengths.forEach(tally => {
          var entryLine: TallyEntryLineModel = new TallyEntryLineModel(
            ++index,
            -1,
            Number(tally),
            this.quickOrderLine.Product.width,
            this.quickOrderLine.Product.thickness,
            0,
            this.quickOrderLine.UnitCostPrice,
            product.inputPer.perId,
            product.imperial ? "ft" : "m",
            product.inputPer.perId,
            this.quickOrderLine.PerToDisplay.perCode,
            true,
            this.quickOrderLine.Product.imperial,
            this.quickOrderLine.PerToDisplay);
          this.quickOrderLine.TallyEntryLines.push(entryLine);
        });
        subscribe(this.quickOrderLine.TallyEntryLines);
      }
      else if (this.quickOrderLine.Product.productType == ProductType.TimberTallied && this.quickOrderLine.Product.productSubtype == ProductSubType.Child) {
        // child tallied product,
        // create tally entry object based on product Length and Qty
        tally = new EpbtFaTallyModel(this.quickOrderLine.Product.tallyLengths);
        var tallyLengths = product.tallyLengths.split(',');
        var index: number = 0;
        this.quickOrderLine.TallyEntryLines = [];
        product.inputPer = product.inputPer ? product.inputPer : this.quickOrderLine.InputPer;
        tallyLengths.forEach(tally => {
          var entryLine: TallyEntryLineModel = new TallyEntryLineModel(
            ++index,
            1,
            Number(tally),
            this.quickOrderLine.Product.width,
            this.quickOrderLine.Product.thickness,
            quantity,
            this.quickOrderLine.UnitSellPrice,
            product.inputPer.perId,
            product.imperial ? "ft" : "m",
            product.inputPer.perId,
            this.quickOrderLine.PerToDisplay.perCode,
            true,
            this.quickOrderLine.Product.imperial,
            this.quickOrderLine.PerToDisplay);
          this.quickOrderLine.TallyEntryLines.push(entryLine);
        });
        subscribe(this.quickOrderLine.TallyEntryLines);
      }
      else {
        subscribe(this.quickOrderLine.TallyEntryLines);
      }
    }
    else {
      this.quickOrderLine.IsTally = false;
      subscribe(null);
    }
  }

  isParentTally(): boolean {
    if (this.quickOrderLine == null) return false;
    return (this.quickOrderLine.Product.productType == ProductType.TimberTallied
      && this.quickOrderLine.Product.productSubtype == ProductSubType.Parent);
  }

  //Get Order Line price using GetDefaultLabelPrice SP
  getOrderLinePrice(useManualPrice: boolean = false, productId: number = null, subscribe: (productPrice: ProductPrice) => void) {
    productId = productId == null ? this.quickOrderLine.Product.productId : productId;

    if (this.quickOrderLine.Discount1 > 0 || this.quickOrderLine.Discount2 > 0) {
      // overwrite manual mode
      useManualPrice = true;
    }

    var UnitSellPriceToConvert = null;

    if (useManualPrice) {
      if (!this.quickOrderLine.IsManuallyPriced)
        UnitSellPriceToConvert = this.quickOrderLine.UnitSellPrice;
    }

    if (this.quickOrderLine.IsTally) {
      // for Tallied product we may need to override quantity based on specified input Per type

      this.quantityFromTally(this.quickOrderLine.InputPer, productId, (newQuantity: any) => {
        this.quickOrderLine.Quantity = newQuantity;
        this.prepareProductPriceRequest(productId, useManualPrice, (result: any) => {
          subscribe(result);
        });
      });
    }
    else {
      this.prepareProductPriceRequest(productId, useManualPrice, (result: any) => {
        subscribe(result);
      });
    }
  }


  /// <summary>
  /// This method is mapping quantity as per given Input Per type
  /// !!! manual dimensions ( width, thickness) not supported 
  /// </summary>
  /// <param name="QuantityTally"></param>
  /// <param name="showWarning"></param>
  /// <returns></returns>

  public quantityFromTally(inputPer: Per, productId: number, subscribe: (newQuantity: number) => void) {
    var widthMetric: number;
    var thicknessMetric: number;

    if (this.quickOrderLine.IsImperial) {
      this.client.getPerConversion(PerDefaults.Inch, PerDefaults.Millimetre, 0, false, 0, 0, 0, 0).subscribe(res => {
        widthMetric = this.quickOrderLine.Product.width * res;
        thicknessMetric = this.quickOrderLine.Product.thickness * res;
        this.getNewQuantity(inputPer, productId, (newQuantity: any) => {
          subscribe(newQuantity);
        });
      });
    }
    else {
      widthMetric = this.quickOrderLine.Product.width;
      thicknessMetric = this.quickOrderLine.Product.thickness;
    }
  }

  public getNewQuantity(inputPer: Per, productId: number, subscribe: (newQuantity: number) => void) {
    var newQuantity: number = 0.0;
    if (this.quickOrderLine.IsImperial) {
      switch (inputPer.perType) {
        case PerType.Unit:
          {
            this.client.getPerConversion(PerDefaults.Each, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.Tally.totalTallyPieces * res;
              subscribe(newQuantity);
            });
            break;
          }
        case PerType.Length:
          {
            this.client.getPerConversion(PerDefaults.Foot, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.TotalTallyLength * res;
              subscribe(newQuantity);
            });
            break;
          }
        case PerType.Volume:
          {
            this.client.getPerConversion(PerDefaults.BoardFoot, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.TotalTallyVolume * res;
              subscribe(newQuantity);
            });
            break;
          }
        case PerType.Area:
          {
            this.client.getPerConversion(PerDefaults.SquareFoot, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.TotalTallyArea * res;
              subscribe(newQuantity);
            });
            break;
          }
        default:
          break;
      }
    }
    else {
      //Metrics goes here
      switch (inputPer.perId) {
        case PerType.Unit: //  same as for imperial
          {
            this.client.getPerConversion(PerDefaults.Each, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.Tally.totalTallyPieces * res;
              subscribe(newQuantity);
            });
            break;
          }
        case PerType.Length: // to Metres
          {
            this.client.getPerConversion(PerDefaults.Metre, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.TotalTallyLength * res;
              subscribe(newQuantity);
            });
            break;
          }
        case PerType.Volume: // to Cubic Metres
          {
            this.client.getPerConversion(PerDefaults.CubicMetre, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.TotalTallyVolume * res;
              subscribe(newQuantity);
            });
            break;
          }
        case PerType.Area: // to Square Metres
          {
            this.client.getPerConversion(PerDefaults.SquareMetre, inputPer.perId, 0, false, 0, 0, 0, 0).subscribe(res => {
              newQuantity = this.quickOrderLine.TotalTallyArea * res;
              subscribe(newQuantity);
            });
            break;
          }
        default:
          break;
      }
    }
  }

  prepareProductPriceRequest(productId: number, useManualPrice: boolean, subscribe: (result: any) => void) {
    var productPriceParameters = new ProductPriceParameters();

    productPriceParameters.productID = productId;
    productPriceParameters.branchID = this.quickOrder.branch.branchID;
    productPriceParameters.customerID = this.quickOrder.customer.customerId;
    productPriceParameters.quantity = this.quickOrderLine.Quantity;
    productPriceParameters.quantityTally = this.quickOrderLine.Tally == null ? null : this.quickOrderLine.Tally.tallyString;
    productPriceParameters.inputPerID = this.quickOrderLine.InputPer.perId;
    productPriceParameters.manualUnitSellPrice = useManualPrice ? this.quickOrderLine.UnitSellPrice : null;
    productPriceParameters.manualDiscount1 = this.quickOrderLine.Discount1;
    productPriceParameters.manualDiscount2 = this.quickOrderLine.Discount2;
    productPriceParameters.perID = this.quickOrderLine.Per.perId;
    productPriceParameters.unitSellPriceToConvert = null; //UnitSellPriceToConvert;
    productPriceParameters.unitSellPriceToConvertPerID = this.quickOrderLine.OldPerId;
    productPriceParameters.totalLength = this.quickOrderLine.Tally == null ? null : this.quickOrderLine.TotalTallyLengthMetric;
    productPriceParameters.totalVolume = this.quickOrderLine.Tally == null ? null : this.quickOrderLine.TotalTallyVolumeMetric;
    productPriceParameters.numberOfPieces = this.quickOrderLine.Tally == null ? 0 : this.quickOrderLine.Tally.totalTallyPieces;
    productPriceParameters.customerAddressID = this.quickOrder.deliveryAddress ? this.quickOrder.deliveryAddress.addressId : 0;

    this.client.getProductPriceEx(productPriceParameters).subscribe(res => {
      subscribe(res);
    });
  }

  prepareProductPriceRequests(productId: number, useManualPrice: boolean, childProducts: any[], subscribe: (result: any) => void) {
    var productPriceParametersList: ProductPriceParameters[] = [];
    childProducts.forEach(item => {
      var productPriceParameters = new ProductPriceParameters();

      productPriceParameters.productID = item.productId;
      productPriceParameters.branchID = this.quickOrder.branch.branchID;
      productPriceParameters.customerID = this.quickOrder.customer.customerId;
      productPriceParameters.quantity = this.quickOrderLine.Quantity;
      productPriceParameters.quantityTally = this.quickOrderLine.Tally == null ? null : this.quickOrderLine.Tally.tallyString;
      productPriceParameters.inputPerID = this.quickOrderLine.InputPer.perId;
      productPriceParameters.manualUnitSellPrice = useManualPrice ? this.quickOrderLine.UnitSellPrice : null;
      productPriceParameters.manualDiscount1 = this.quickOrderLine.Discount1;
      productPriceParameters.manualDiscount2 = this.quickOrderLine.Discount2;
      productPriceParameters.perID = this.quickOrderLine.Per.perId;
      productPriceParameters.unitSellPriceToConvert = null; //UnitSellPriceToConvert;
      productPriceParameters.unitSellPriceToConvertPerID = this.quickOrderLine.OldPerId;
      productPriceParameters.totalLength = this.quickOrderLine.Tally == null ? null : this.quickOrderLine.TotalTallyLengthMetric;
      productPriceParameters.totalVolume = this.quickOrderLine.Tally == null ? null : this.quickOrderLine.TotalTallyVolumeMetric;
      productPriceParameters.numberOfPieces = this.quickOrderLine.Tally == null ? 0 : this.quickOrderLine.Tally.totalTallyPieces;
      productPriceParameters.customerAddressID = this.quickOrder.deliveryAddress ? this.quickOrder.deliveryAddress.addressId : 0;

      productPriceParametersList.push(productPriceParameters);
    });

    this.client.getProductPriceExs(productPriceParametersList).subscribe(res => {
      subscribe(res);
    });
  }

  //Generating reserverd Order Id and Order Number Start

  getReservedDocumentID(subscribe: (orderId: number) => void) {
    this.client.getReservedDocumentID("OrderHeader", "OrderID").subscribe(orderId => {
      subscribe(orderId);
    });
  }

  getReservedOrderNumber(subscribe: (orderNumber: string) => void) {
    this.client.getReservedOrderNumber(OrderType.Order).subscribe(orderNumber => {
      subscribe(orderNumber);
    });
  }

  //Generating reserverd Order Id and Order Number End

  getPerConversion(fromPerID: number, toPerID: number, productId: number, imperial: boolean, thickness: number, width: number, length: number, weight: number,
    subscribe: (perConversion: number) => void) {
    var perConversion: number;
    this.client.getPerConversion(fromPerID, toPerID, productId, imperial, thickness, width, length, weight).subscribe(res => {
      if (res != null) {
        perConversion = res;
      }
      subscribe(perConversion);
    });
  }

  updateLineTotals(subscribe: (flag: boolean) => void) {
    let perConvInchToMillimetre = 0;
    let perConvMillimetreToInch = 0;
    let perConvFootToMetre = 0;
    let perCubicMetreToBoardFoot = 0;

    this.getPerConversion(PerDefaults.Inch, PerDefaults.Millimetre, 0, false, 0, 0, 0, 0, (perConversion1: number) => {
      perConvInchToMillimetre = perConversion1;
      console.log(perConvInchToMillimetre, "perConvInchToMillimetre");

      this.getPerConversion(PerDefaults.Millimetre, PerDefaults.Inch, 0, false, 0, 0, 0, 0, (perConversion2: number) => {
        perConvMillimetreToInch = perConversion2;

        this.getPerConversion(PerDefaults.Foot, PerDefaults.Metre, 0, false, 0, 0, 0, 0, (perConversion3: number) => {
          perConvFootToMetre = perConversion3;

          this.getPerConversion(PerDefaults.CubicMetre, PerDefaults.BoardFoot, 0, false, 0, 0, 0, 0, (perConversion4: number) => {
            perCubicMetreToBoardFoot = perConversion4;

            this.quickOrderLine.Tally.getTotalsFromTally(this.quickOrderLine.Product.thickness, this.quickOrderLine.Product.width, this.quickOrderLine.IsImperial, perConvInchToMillimetre, perConvMillimetreToInch,
              perConvFootToMetre, perCubicMetreToBoardFoot);

            this.quickOrderLine.TotalTallyLength = this.quickOrderLine.Tally.totalTallyLength;
            this.quickOrderLine.TotalTallyArea = this.quickOrderLine.Tally.totalTallyArea;
            this.quickOrderLine.TotalTallyVolume = this.quickOrderLine.Tally.totalTallyVolume;

            this.quickOrderLine.TotalTallyLengthMetric = this.quickOrderLine.Tally.totalTallyLengthMetric;
            this.quickOrderLine.TotalTallyAreaMetric = this.quickOrderLine.Tally.totalTallyAreaMetric;
            this.quickOrderLine.TotalTallyVolumeMetric = this.quickOrderLine.Tally.totalTallyVolumeMetric;
            subscribe(true);
          });
        });
      });
    });
  }

  updateTaxes(subscribe: (flag: boolean) => void) {
    var manualOrderLines: ManualOrderLine[] = [];
    var taxCalculationParameters: TaxCalculationParameter[] = [];

    this.quickOrder.Lines.forEach(line => {
      if (line.ManualOrderLineType) {
        var manualOrderLine: ManualOrderLine = new ManualOrderLine();
        manualOrderLine.lineId = line.LineNumber;
        manualOrderLine.manualOrderLineTypeId = line.ManualOrderLineType.manualOrderLineTypeId;
        manualOrderLine.amount = line.TotalSellPrice;
        manualOrderLines.push(manualOrderLine);
      }
      else {
        var taxCalculationParameter: TaxCalculationParameter = new TaxCalculationParameter();
        taxCalculationParameter.lineId = line.LineNumber;
        taxCalculationParameter.productId = line.Product.productId;
        taxCalculationParameter.sellPrice = line.TotalSellPrice;
        taxCalculationParameters.push(taxCalculationParameter);
      }
    });

    var getManualLineTaxesRequest: GetManualLineTaxesRequest = new GetManualLineTaxesRequest();
    getManualLineTaxesRequest.webTrackUserId = 0;//this.webTrackUser.userId;
    getManualLineTaxesRequest.customerId = this.quickOrder.customer.customerId;

    if (this.quickOrder.selectedSalesType == 1)
      getManualLineTaxesRequest.saleType = GetManualLineTaxesRequestSaleType.CollectNow;
    else if (this.quickOrder.selectedSalesType == 2)
      getManualLineTaxesRequest.saleType = GetManualLineTaxesRequestSaleType.CollectLater;
    else if (this.quickOrder.selectedSalesType == 3)
      getManualLineTaxesRequest.saleType = GetManualLineTaxesRequestSaleType.Delivered;

    getManualLineTaxesRequest.deliveryAddressId = this.quickOrder.deliveryAddress ? this.quickOrder.deliveryAddress.addressId : 0;
    getManualLineTaxesRequest.branchId = this.quickOrder.branch.branchID;
    getManualLineTaxesRequest.lines = manualOrderLines;

    var getNewModeTaxesForCartRequest: GetNewModeTaxesForCartRequest = new GetNewModeTaxesForCartRequest();

    getNewModeTaxesForCartRequest.webTrackUserId = 0;//this.webTrackUser.userId;
    getNewModeTaxesForCartRequest.customerId = this.quickOrder.customer.customerId;

    if (this.quickOrder.selectedSalesType == 1)
      getNewModeTaxesForCartRequest.saleType = GetNewModeTaxesForCartRequestSaleType.CollectNow;
    else if (this.quickOrder.selectedSalesType == 2)
      getNewModeTaxesForCartRequest.saleType = GetNewModeTaxesForCartRequestSaleType.CollectLater;
    else if (this.quickOrder.selectedSalesType == 3)
      getNewModeTaxesForCartRequest.saleType = GetNewModeTaxesForCartRequestSaleType.Delivered;

    getNewModeTaxesForCartRequest.deliveryAddressId = this.quickOrder.deliveryAddress ? this.quickOrder.deliveryAddress.addressId : 0;
    getNewModeTaxesForCartRequest.branchId = this.quickOrder.branch.branchID;
    getNewModeTaxesForCartRequest.useThisTaxAreaID = this.quickOrder.taxArea.taxAreaID;
    getNewModeTaxesForCartRequest.lines = taxCalculationParameters;

    if (manualOrderLines.length > 0 && taxCalculationParameters.length > 0) {
      this.client.getNewModeTaxesForCart(getNewModeTaxesForCartRequest).subscribe(newModeTaxesForCartResult => {
        this.updateNewModeTaxesForCart(newModeTaxesForCartResult);
        this.client.getManualLineTaxes(getManualLineTaxesRequest).subscribe(manualLineTaxesResult => {
          manualLineTaxesResult.forEach(item => {
            this.updateManualLineTaxes(manualLineTaxesResult);
            subscribe(true);
          });
        });
      });
    }
    else {
      if (manualOrderLines.length > 0) {
        this.client.getManualLineTaxes(getManualLineTaxesRequest).subscribe(manualLineTaxesResult => {
          this.updateManualLineTaxes(manualLineTaxesResult);
          subscribe(true);
        });
      }

      if (taxCalculationParameters.length > 0) {
        this.client.getNewModeTaxesForCart(getNewModeTaxesForCartRequest).subscribe(newModeTaxesForCartResult => {
          this.updateNewModeTaxesForCart(newModeTaxesForCartResult);
          subscribe(true);
        });
      }
    }
  }

  updateNewModeTaxesForCart(newModeTaxesForCartResult: TaxCalculationResult[]) {
    if (newModeTaxesForCartResult.length == 1 && newModeTaxesForCartResult[0].cartTotalLine && this.quickOrder.Lines.length > 0)
      this.quickOrder.Lines[0].TotalTax = newModeTaxesForCartResult[0].taxAmount;
    else {
      newModeTaxesForCartResult.forEach(item => {
        let index = this.quickOrder.Lines.findIndex(x => x.LineNumber == item.lineId);
        if (index != -1)
          this.quickOrder.Lines[index].TotalTax = item.taxAmount
      });
    }
  }

  updateManualLineTaxes(manualLineTaxesResult: ManualOrderLine[]) {
    manualLineTaxesResult.forEach(item => {
      let index = this.quickOrder.Lines.findIndex(x => x.LineNumber == item.lineId);
      if (index != -1)
        this.quickOrder.Lines[index].TotalTax = item.tax;
    });
  }

  clearData() {
    this.quickOrder = null;
    this.quickOrderLine = null;
    this.wizardStep = 0;
    this.fromDashbard = false;
    //this.selectedBranchId = 1;
    if (this.webTrackUser && this.webTrackUser.bisTrackBranch)
      this.selectedBranchId = this.webTrackUser.bisTrackBranch.branchID;
    this.selectedTextAreaId = -1;
    this.selectedTransactionType = 1;
    this.customerForDesktop = null;
    this.productForDesktop = null;
    this.contactForDesktop = null;
    this.addressForDesktop = null;
    this.selectedRelatedproduct = null;
    this.completeOrderFlag = false;
    this.searchString = "";
    this.productSelectFlag = false;
    //localStorage.removeItem("QuickOrder");
  }
  //Quick Order Line Code End

  //Quick order related products code
  createRelatedProductOrderLine(count, subscribe: (flag: boolean) => void) {
    if (this.selectedRelatedproduct && this.selectedRelatedproduct.length > 0) {
      var quantityRelatedProducts = this.selectedRelatedproduct.filter(item => item.quantity > 0);
      if (quantityRelatedProducts && quantityRelatedProducts.length > 0) {
        this.faService.openOrCloseProcessDialog();
        this.addRelatedProducts(quantityRelatedProducts, count, (flag: boolean) => {
        });
      }
      else
        this.router.navigate(['/home/quickorder']);
    }
  }

  addRelatedProducts(data, count, subscribe: (flag: boolean) => void) {
    this.createQuickOrderLine(data[count].product, QuantityType.Per, data[count].quantity, (quickOrderLine: any) => {

      this.quickOrderLine = quickOrderLine;
      var index = this.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderLine.LineNumber);
      if (index != -1) {
        this.quickOrder.Lines[index] = this.quickOrderLine;
      }
      else {
        this.quickOrder.LineAdd(this.quickOrderLine);
      }

      if (count + 1 == data.length) {
        this.selectedRelatedproduct = null;
        this.faService.openOrCloseProcessDialog();
        this.router.navigate(['/home/quickorder']);
      }
      else {
        this.addRelatedProducts(data, count + 1, (flag: boolean) => {
        });
      }
    });
  }


  checkMaxQuantityLimitForRelatedProducts(): boolean {
    let flag: boolean = true;
    if (this.selectedRelatedproduct) {
      this.selectedRelatedproduct.forEach(element => {
        if (element.quantity > 1000000) {
          flag = false;
        }
      });
    }
    return flag;
  }

  getKitPrice(kit: any): Observable<KitProductPrice> {
    return this.client.getKitProductLinePrice(kit);
  }

  /**
   * Save kit selection to quick order service
   */
  saveKitChoices(lineNumber: number, kit: any, selection: any, quantity: number) {
    this.kits[lineNumber] = {
      kit: kit,
      selection: selection,
      quantity: quantity
    };
  }
}
